import { Button, Divider, Radio, RadioChangeEvent } from 'antd';
import React from 'react';
import { BadgeStudioSortOptions } from '../../../model/BadgeModel';
import { SortDirections } from '../../../model/CommonModel';
import styles from './sortByContent.module.scss';

type Props = {
	sortField: BadgeStudioSortOptions;
	sortDirection: SortDirections;
	handleSortByOptionChanged: (e: RadioChangeEvent) => void;
	handleSortDirectionOptionChanged: (e: RadioChangeEvent) => void;
	onClearSortBy: () => void;
	onSortBy: () => void;
};

const SortByContent: React.FC<Props> = ({ sortField, sortDirection, handleSortByOptionChanged, handleSortDirectionOptionChanged, onClearSortBy, onSortBy }) => {
	return (
		<div className={styles.container}>
			<Radio.Group value={sortField} onChange={handleSortByOptionChanged}>
				<div>
					<Radio value={BadgeStudioSortOptions.Name}>{_('Name')}</Radio>
				</div>
				<div>
					<Radio value={BadgeStudioSortOptions.LastUpdated}>{_('LastUpdated')}</Radio>
				</div>
			</Radio.Group>
			<Divider className={styles.divider} />
			<Radio.Group value={sortDirection} onChange={handleSortDirectionOptionChanged}>
				<div>
					<Radio value={SortDirections.Ascend}>{_('Ascend')}</Radio>
				</div>
				<div>
					<Radio value={SortDirections.Descend}>{_('Descend')}</Radio>
				</div>
			</Radio.Group>
			<Divider className={styles.divider} />
			<div className={styles.sortFooter}>
				<Button onClick={onClearSortBy}>{_('Reset')}</Button>
				<Button type='primary' onClick={onSortBy} disabled={false}>
					{_('Sort')}
				</Button>
			</div>
		</div>
	);
};

export { SortByContent };
